
import React, { useRef } from 'react';
import { Upload } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface FileUploaderProps {
  selectedFile: File | null;
  onChange: (file: File | null) => void;
  currentFileName?: string | null;
}

const FileUploader: React.FC<FileUploaderProps> = ({ 
  selectedFile, 
  onChange,
  currentFileName = null
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      onChange(file);
      console.log("File selected:", file.name, "Size:", formatFileSize(file.size), "Type:", file.type);
    } else {
      console.log("No file selected from input");
    }
  };

  const handleButtonClick = () => {
    // Programmatically trigger the file input
    fileInputRef.current?.click();
  };

  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + " bytes";
    else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
    else return (bytes / 1048576).toFixed(1) + " MB";
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center">
        <Input
          id="file-upload"
          type="file"
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
          // Removed the accept attribute to allow any file type
        />
        <div className="flex-1">
          <Button 
            type="button" 
            variant="outline" 
            className="w-full flex justify-center items-center gap-2 py-1"
            onClick={handleButtonClick}
          >
            <Upload size={16} />
            {selectedFile 
              ? selectedFile.name
              : currentFileName 
                ? 'Replace file' 
                : 'Upload Reward'
            }
          </Button>
        </div>
        
        {selectedFile && (
          <div className="ml-4 text-sm text-muted-foreground">
            ({formatFileSize(selectedFile.size)})
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploader;
